import { Spin } from 'antd';
import React, { useState, Suspense, lazy, useContext, useRef, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import Loading from '@view/compoents/loading/loading'
import { AppContext } from '@utils/AppContext';
// 引入组件
const Coupon = lazy(() => import('@view/Coupon'))
const Layout = () => {
    const location = useLocation();
    const { globalLoading } = useContext(AppContext);
    const [loading, setLoading] = useState(globalLoading)
    const loadingDelayRef = useRef()

    useEffect(() => {
        clearTimeout(loadingDelayRef.current)
        loadingDelayRef.current = setTimeout(() => {
            setLoading(globalLoading)
        }, 100)
    }, [globalLoading])

    useEffect(() => {
        if(location.pathname == '/') {
            document.title = 'PhotoStudio AI'
        }
    }, [location]);

    useEffect(() => {
        const html = document.querySelector('html')
        html.style.setProperty('--min-font-size', '0px');
        html.style.setProperty('--max-font-size', '100px');
        html.style.setProperty('--base-width', '768');
    }, [])

    return (
        <Suspense fallback={<div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spin size="large"/></div>}>
            {
                loading ?
                <Loading loadingText={typeof loading === 'boolean' ? '上传中' : loading} /> :
                null
            }
            <Routes>
                <Route path="coupon" element={<Coupon/>} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Suspense>
    )
}

export default Layout